import PushNotifications from './PushNotifications';

export default PushNotifications;
